function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import t from "deepmerge";
import { set as e, get as r } from "shvl";
export default function (n, o, u) {
  function i(t, e, r) {
    try {
      return (r = e.getItem(t)) && void 0 !== r ? JSON.parse(r) : void 0;
    } catch (t) {}
  }

  if (o = (n = n || {}).storage || window && window.localStorage, u = n.key || "vuex", !function (t) {
    try {
      return t.setItem("@@", 1), t.removeItem("@@"), !0;
    } catch (t) {}

    return !1;
  }(o)) throw new Error("Invalid storage instance given");
  return function (c) {
    var a = r(n, "getState", i)(u, o);
    "object" == _typeof(a) && null !== a && c.replaceState(t(c.state, a, {
      arrayMerge: n.arrayMerger || function (t, e) {
        return e;
      },
      clone: !1
    })), (n.subscriber || function (t) {
      return function (e) {
        return t.subscribe(e);
      };
    })(c)(function (t, i) {
      (n.filter || function () {
        return !0;
      })(t) && (n.setState || function (t, e, r) {
        return r.setItem(t, JSON.stringify(e));
      })(u, (n.reducer || function (t, n) {
        return 0 === n.length ? t : n.reduce(function (n, o) {
          return e(n, o, r(t, o));
        }, {});
      })(i, n.paths || []), o);
    });
  };
}
;